/*
|--------------------------------------------------------------------------
| Views: Basic Headlines
|--------------------------------------------------------------------------
*/

/**
 * Basic Headlines
 * @namespace
 */
 __gh__webApp.views.basicHeadlines = {

	/**
	 * Post bucket laydown callbacks
	 * @param {object} bucket - bucket object
	 */
	"callbacks": function(bucket){
		var viewName	= bucket.view.name,
			commonJS	= __gh__webApp.common,
			social		= __gh__webApp.social;

		//Twitter
		if (commonJS.hasString(viewName.toLowerCase(), "twitter"))
		{
		    social.twitter.loadAllWidgets();
		}
	},


	"getSubView": function(bucket){
		var commonJS			= __gh__webApp.common,
			commonViewJS		= __gh__webApp.views.common,
			validateBucket		= __gh__webApp.data.validate.bucket,
			items 				= (bucket.items.main) ? bucket.items.main : {},
			hasFeaturedEmbed	= validateBucket.hasFeaturedEmbed(bucket),
			viewFolder		 	= "buckets/basicHeadlines",
			viewFolder			= (hasFeaturedEmbed) ? viewFolder +"/featuredEmbed" : viewFolder,
			viewName,hasImage,hasFeatured;
	
		//Move 2nd image to first if the first doesn't have one
		var featuredImagePosition = __gh__webApp.data.itemValidator({"data":items.slice(0,2),"required":1,"validationMethod":"hasImage"});
		if(featuredImagePosition!==false && featuredImagePosition!==0){
			items.move(featuredImagePosition,0);
		}
	
	
		viewName 				= viewFolder+"/default";
		hasFeaturedImage		= (featuredImagePosition !== false) ? true : false;
		hasFeatured 			= (hasFeaturedImage || hasFeaturedEmbed),
		bucket.hasFeaturedImage = hasFeaturedImage;
	
	
		//Set adPosition
		if (bucket.hasAd) {
			bucket.adPosition 	= (commonJS.isOdd(commonJS.getRandomNumber())) ? "top" : "bottom";
		}
	
		
		
		//featuredTwitter - image
		var hasTwitter 		= validateBucket.hasTwitter(bucket);
		if (!hasFeaturedEmbed && hasFeaturedImage && hasTwitter){
			itemCount 		= 11,
			viewName 		= viewFolder+"/featuredTwitter";
			getItems		= commonViewJS.splitItems(items,itemCount,bucket);
			
			bucket.view.name 	= viewName,	
			bucket.items 		= {
				"main"				:getItems.main.slice(0,1),
				"cols":{
					"col1"			:getItems.main.slice(1,6)
				},
				"moreHeadlines"		:getItems.moreHeadlines
			};
			return bucket;
	
		}
		
		//featuredTwitter - embed
		if (hasFeaturedEmbed && hasTwitter){
			itemCount 		= 10,
			viewName 		= viewFolder+"/featuredTwitter";
			getItems		= commonViewJS.splitItems(items,itemCount,bucket);
			
			bucket.view.name 	= viewName,	
			bucket.items 		= {
				"cols":{
					"col1"			:getItems.main.slice(0,5)
				},
				"moreHeadlines"		:getItems.moreHeadlines
			};
			return bucket;
	
		}
		
		
		// noFeaturedTwitter
		if (!hasFeatured && hasTwitter){
			itemCount 		= 6,
			viewName 		= viewFolder+"/noFeaturedTwitter",
			getItems		= commonViewJS.splitItems(items,itemCount,bucket);
			bucket.view.name 	= viewName,
			bucket.items 		= {
				"cols":{
					"col1"			:getItems.main.slice(0,3),
					"col2"			:getItems.main.slice(3,6)
				},
				"moreHeadlines"		:getItems.moreHeadlines
			};
			return bucket;
		}
	
	
	
	
		// default - image
		if (!hasFeaturedEmbed && hasFeaturedImage){
			itemCount 		= (bucket.hasAd) ? 8 : 11,
			viewName 		= viewFolder+"/default";
			getItems		= commonViewJS.splitItems(items,itemCount,bucket);
	
			//Update bucket
			bucket.view.name 	= viewName,
			bucket.items 		= {
				"main"				:getItems.main.slice(0,1),
				"cols":{
					"col1"			:getItems.main.slice(1,6),
					"col2"			:getItems.main.slice(6,itemCount),
				},
				"moreHeadlines"		:getItems.moreHeadlines
			};
			return bucket;
	
		}
		
		// default - embed
		if (hasFeaturedEmbed){
			itemCount 		= (bucket.hasAd) ? 7 : 10,
			viewName 		= viewFolder+"/default";
			getItems		= commonViewJS.splitItems(items,itemCount,bucket);
	
			//Update bucket
			bucket.view.name 	= viewName,
			bucket.items 		= {
				"cols":{
					"col1"			:getItems.main.slice(0,5),
					"col2"			:getItems.main.slice(5,itemCount),
				},
				"moreHeadlines"		:getItems.moreHeadlines
			};
			return bucket;
	
		}
		
	
	
	
	
		// noFeatured
		if (!hasFeatured){
			itemCount 		= (bucket.hasAd) ? 6 : 9,
			viewName 		= viewFolder+"/noFeatured",
			getItems		= commonViewJS.splitItems(items,itemCount,bucket);
	
			bucket.view.name 	= viewName,
			bucket.items 		= {
				"cols":{
					"col1"			:getItems.main.slice(0,3),
					"col2"			:getItems.main.slice(3,6)
				},
				"moreHeadlines"		:getItems.moreHeadlines
			};
	
			if(!bucket.hasAd){
				bucket.items.cols.col3 = getItems.main.slice(6,9);
			}
	
			return bucket;
		}
	
	}
};
